import { render, staticRenderFns } from "./CategoryIcon.vue?vue&type=template&id=ce01d7e8&scoped=true&"
import script from "./CategoryIcon.vue?vue&type=script&lang=js&"
export * from "./CategoryIcon.vue?vue&type=script&lang=js&"
import style0 from "./CategoryIcon.vue?vue&type=style&index=0&id=ce01d7e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce01d7e8",
  null
  
)

export default component.exports